/**
 * regex password format
 * @returns {regex}
 */
export const formatPasswordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$/;